import styled from 'styled-components';
import {TimerIcon} from '../../atoms/Icons';
import TextInput from '../../atoms/TextInput';
import ContainedButton,{ContainedButtonBase} from '../../atoms/ContainedButton';
import TextButton from '../../atoms/TextButton';
import {WithCaption} from '../../atoms/Caption';
import {DividerColor,OnPrimary,DisableColor,Grey300,Grey500,Grey600, ColorDefs} from '../../Colors';

const defaultStyle = {
	Wrapper : styled.label`
        display : inline-block;
        padding : 1rem;
        border-radius : 5px;
        border : solid 1px ${DividerColor};
        background-color : ${OnPrimary};
        cursor : pointer;
    `,
	TimerIcon : styled(TimerIcon)`
        color : ${Grey500};
        font-size : 2rem;
    `,
	TextInput : WithCaption({
		fontSize : '0.5rem',
		top : '-70%',
		right : 0,
	})(
		styled(TextInput).attrs(
			{
				type : 'number',
				borderType : 'underlined',
				min : 0,
				max : 60
			}
		)`
            text-align : center;
            width : 5rem;
        `
	),
	OkButton : styled(ContainedButtonBase)`
        color : ${Grey500};
        margin-left : 2rem;
        &:focus{
            border: 1px solid ${Grey600};
            color : ${Grey600};
            background-color : ${Grey300};
        }
        &:hover{
            border: 1px solid ${Grey600};
            color : ${Grey600};
            background-color : ${Grey300};
        }
        &:disabled{
            color : ${DisableColor};
            border: none;
        }
    `,
	TextButton : styled(TextButton).attrs({
		color : ColorDefs.default
	})``
};

const mobileStyle = {
	TextInput : styled(defaultStyle.TextInput)`
        width : 100%
    `,
	Wrapper : styled.div`
        padding : 1rem;
    `,
	ModalHeader : styled.div`
        font-size : 2rem;
        text-align : center;
    `,
	SelectWrapper :styled.div`
        text-align : center;
        padding : 1rem 0 1rem 0;
        & > select {
            &:focus {
                outline : none;
            }
            margin-right : 1.5rem
        }
    `,
	ButtonWrapper : styled.div`
        padding : 1rem 0 0 0;
        text-align : center;
    `,
	OkButton : styled(ContainedButton)`
        margin-left : 2rem;
        width : 80%;
    `
};

export default defaultStyle;
export {mobileStyle};